import { create } from "zustand";

const boxStore = create((set) => ({
  relatedBoxTypes: [],
  setRelatedBoxTypes: (list) => {
    set((state) => {
      return { relatedBoxTypes: list };
    });
  },
  boxTypeOverview: [],
  resetBoxTypeOverview: () => {
    set((state) => {
      return { boxTypeOverview: [] };
    });
  },
  addRemoveBoxTypeOverview: (boxType) => {
    console.log("boxType", boxType);
    set((state) => {
      const btName = boxType.names.plural;
      const overviewNames = state.boxTypeOverview.map((bt) => bt.names.plural);
      if (overviewNames.includes(btName)) {
        return {
          boxTypeOverview: state.boxTypeOverview.filter(
            (bt) => bt.names.plural !== btName
          ),
        };
      } else {
        return { boxTypeOverview: [...state.boxTypeOverview, boxType] };
      }
    });
  },
}));

export default boxStore;
